/* BHALLO — atualiza a barra de frete gratis conforme o carrinho muda.

   Limiar por VALOR: R$ 399. O motivo de nao ser "2 pecas" esta explicado no
   comentario de snippets/bhallo-freeship.liquid (resumo: o cupom FRETE2 da
   Yampi funciona digitado mas nao aplica sozinho — chamado aberto com eles). */
(function () {
  var MIN_VALOR = 39900; // R$ 399,00 em centavos

  function fmt(centavos) {
    return 'R$ ' + (centavos / 100).toFixed(2).replace('.', ',');
  }

  function update(carrinho) {
    var total = carrinho.total_price;
    var temFrete = total >= MIN_VALOR;
    var pct = Math.max(0, Math.min(100, Math.round((total / MIN_VALOR) * 100)));

    var barras = document.querySelectorAll('.bhallo-freeship');
    for (var i = 0; i < barras.length; i++) {
      var el = barras[i];
      var fill = el.querySelector('.bhallo-freeship__fill');
      var text = el.querySelector('.bhallo-freeship__text');

      if (fill) fill.style.width = pct + '%';
      if (!text) continue;

      if (temFrete) {
        el.classList.add('is-reached');
        text.innerHTML = 'Você garantiu <strong>FRETE GRÁTIS</strong> na sua compra! 🎉';
      } else {
        el.classList.remove('is-reached');
        text.innerHTML = 'Faltam <strong>' + fmt(MIN_VALOR - total) +
          '</strong> para o <strong>FRETE GRÁTIS</strong> 🚚';
      }
    }
  }

  function refresh() {
    if (!document.querySelector('.bhallo-freeship')) return;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(update)
      .catch(function () {});
  }

  // intercepta chamadas de carrinho pra atualizar a barra
  var origFetch = window.fetch;
  if (origFetch) {
    window.fetch = function () {
      var res = origFetch.apply(this, arguments);
      try {
        var a0 = arguments[0];
        var u = typeof a0 === 'string' ? a0 : (a0 && a0.url) || '';
        if (/\/cart\/(add|change|update|clear)/i.test(u)) {
          res.then(function () { setTimeout(refresh, 200); });
        }
      } catch (e) {}
      return res;
    };
  }

  if (document.readyState !== 'loading') refresh();
  else document.addEventListener('DOMContentLoaded', refresh);
})();
